function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgNet(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M49.69 4.029a49.683 49.683 0 00-3.38 0C22.79 4.92 4 24.269 4 48c0 23.73 18.79 43.08 42.31 43.971a49.683 49.683 0 003.38 0C73.21 91.08 92 71.73 92 48 92 24.269 73.21 4.92 49.69 4.029zM83.769 44h-15.91c-.909-13.4-6.27-24.09-10.739-30.84C71.33 16.88 82.13 29.06 83.769 44zM48.01 14.18c3.93 5.12 10.7 15.8 11.83 29.82H36.16c1.13-13.96 7.92-24.68 11.85-29.82zm-9.13-1.02C34.41 19.91 29.05 30.6 28.141 44h-15.91C13.87 29.06 24.67 16.88 38.88 13.16zM12.231 52h15.91C29.05 65.391 34.4 76.08 38.87 82.83c-14.21-3.71-25-15.89-26.639-30.83zM47.99 81.82C44.06 76.7 37.29 66.019 36.16 52h23.68c-1.13 13.96-7.91 24.68-11.85 29.82zm9.14 1.01C61.6 76.08 66.95 65.39 67.859 52h15.91C82.13 66.94 71.34 79.12 57.13 82.83z"
  }));
}

SvgNet.clsName = 'icon-www__net';
SvgNet.remarkName = 'unknown';
export default SvgNet;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Net.js
// module id = 2394
// module chunks = 17 18